// Must be synced with theme.js
export const PAGE_SIDEBAR_WIDTH = 384;

export const BREAKPOINT_WIDTHS = {
  sm: 480,
  md: 768,
  lg: 1024,
};

export const MEDIA_QUERIES = {
  sm: `(max-width: ${BREAKPOINT_WIDTHS.sm / 16}em)`,
  md: `(max-width: ${BREAKPOINT_WIDTHS.md / 16}em)`,
  lg: `(max-width: ${BREAKPOINT_WIDTHS.lg / 16}em)`,
  reducedMotion: "(prefers-reduced-motion)",
};
